import { render } from "./App.vue?vue&type=template&id=5dbba381"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5dbba381&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__